import React from "react";
import styles from "./RoutingDecisionModal.module.css";
import {CloseImageButton} from "../../../closeImageButton/CloseImageButton";
import {RoutingDetails} from "../../../../modules/transcripts/page/routingDetails/RoutingDetails";
import {TranscriptRoutingDecisionUi} from "../../../../../api/generated";

interface RoutingDecisionModalProps {
    routingDecision: TranscriptRoutingDecisionUi;
    handleClose: () => void;
}

export const RoutingDecisionModal: React.FC<RoutingDecisionModalProps> = ({routingDecision, handleClose}) => (
    <div className={styles.wrapper}>
        <div className={styles.header}>
            <span className={styles.title}>Routing decision</span>
            <CloseImageButton onClose={handleClose}/>
        </div>
        <div className={styles.body}>
            <RoutingDetails routingDecision={routingDecision}/>
        </div>
    </div>
);
